import { ethers } from "ethers";
const { ethereum } = window;
let SignerFn;
if(ethereum){
    const provider = new ethers.providers.Web3Provider(ethereum);
    SignerFn = provider.getSigner();
}

export default SignerFn